export const EMPTY_CELL_VALUE = '-';
export const EMPTY_CELL_PLACEHOLDER = '';

export const NONE_EMPTY_CELL_VALUE = 'N/A';

export const SELECT_NONE_OPTION = {
  label: 'None',
  value: 'null',
};

export function replaceStringNull(value?: string | number | boolean | null) {
  return value === SELECT_NONE_OPTION.value ? null : value;
}
